import {Directive, ElementRef, Input} from '@angular/core';

// class HeadlineTitleBase {
//     constructor(public _elementRef: ElementRef) {
//     }
// }

@Directive({
  selector: '[app-headline-title]',
    exportAs: 'headlineTitle',
    host: { class: 'averia-headline-title mat-primary', '[class.sticky]': 'sticky' },
    inputs: ['color'],
  standalone: false
})
export class HeadlineTitleDirective {
    @Input() sticky = true;
}

@Directive({
  selector: '[app-headline-actions], app-headline-actions',
    host: { class: 'averia-headline-actions' },
  standalone: false
})
export class HeadlineActionsDirective {
}
